import React from "react";
import { connect } from "react-redux";

import { goTo } from "../tools";
import { movil } from "../app-movil";

const mapState = (state) => {
	return {
		loading: state.global.loading,
		email: state.registro.email,
		password: state.registro.password
	};
};

const mapDispatch = (dispatch) => {
	return {
		pasoSiguiente: () => {
			dispatch({ "type": "REGISTRO_PASO_SIGUIENTE" });
		}
	};
};

class Correo extends React.Component {
	
	cerrar = () => {
		let mensaje = {email: this.props.email, password: this.props.password};
		movil("registro", mensaje);
			
		this.props.pasoSiguiente();
		goTo("gnp/login");
		//window.location.href = '/#!/';
	}
	
	render() {
		return (
			<div>
				{/*<div className='datos-wrap mt-10'>
					<div className="row">
						<div className="col-xs-12 txt-center">
							<h3>Transacción exitosa</h3>
						</div>
					</div>
					<div className="row">
						<div className="col-xs-12 txt-center">
							<img src={require("../img/vector_ok.png")} />
							<br />
						</div>
					</div>
					<div className="row">
						<div className="col-xs-12 txt-center">
							<p>Tu solicitud de registro ha sido exitosa, recibirás un correo electrónico para acceder a tu  información.</p>
						</div>
					</div>
					<div className="row">
						<div className="col-xs-12 txt-center">
							<button className='orange-circle' onClick={this.cerrar.bind(this)}>
								<i></i>
							</button>
						</div>
					</div>
				</div>*/}
				<div className='modal fade in' style={{"display":"block"}} id='modal-bienvenida' tabIndex='-1' role='dialog' aria-labelledby='modal-bienvenida'>
					<div className="modal-backdrop fade in" style={{"zIndex":"0"}}></div>
					<div className='modal-dialog' role="document">
						<div className='modal-content'>
							<div className='modal-header'>
								<h4 className='modal-title orange-text'>Transacción exitosa</h4>
							</div>
							<div className='txt-black txt-center pd-15'>
								<p>Tu solicitud de registro ha sido exitosa, recibirás un correo electrónico para concluir tu registro.</p>
							</div>
							<div className='modal-footer'>
								<button type='button' onClick={this.cerrar} className='btn orange-btn' data-dismiss='modal'>Aceptar</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default connect(mapState, mapDispatch)(Correo);


// WEBPACK FOOTER //
// ./src/gnp-registro-completo/correo.cmpt.js